import { reasonTypes } from "../ContentSettingsAdvisory";

const getGradeRange = ({
  grade_minimum: gradeMinimum,
  grade_maximum: gradeMaximum,
}) => {
  const formattedMinimumGrade = gradeMinimum === 0 ? "K" : gradeMinimum;

  if (gradeMinimum === gradeMaximum) return formattedMinimumGrade;

  return `${formattedMinimumGrade}-${gradeMaximum}`;
};

const getAdvisoryDetails = (markers) => {
  const { flagged_at_my_admin_level: flaggedAtMyAdminLevel, reason } =
    markers[0];

  const hasSingleGrade =
    markers.length === 1 &&
    markers[0]?.grade_minimum === markers[0]?.grade_maximum;

  if (!flaggedAtMyAdminLevel) {
    const grades = markers.reduce((acc, marker, i) => {
      if (i === 0) return getGradeRange(marker);
      if (i === markers.length - 1)
        return `${acc} and ${getGradeRange(marker)}`;
      return `${acc}, ${getGradeRange(marker)}`;
    }, "");

    const gradeLabel = hasSingleGrade ? "grade" : "grades";

    return `This advisory applies to ${gradeLabel} ${grades}.`;
  }

  const grades = markers.map((marker) => {
    const type = marker.block_teacher_view ? "Block" : "Flag with advisory";
    const gradeRange = getGradeRange(marker);
    return `${gradeRange} ${type}`;
  });

  const gradeLabel = hasSingleGrade ? "this grade level" : "these grade levels";

  if (flaggedAtMyAdminLevel && reason === reasonTypes.SCHOOL_ADVISORY) {
    return `Either you or another school admin has flagged this content for ${gradeLabel}: ${grades.join(", ")}. Review your settings in the admin console to adjust.`;
  }

  return `This content is flagged for ${gradeLabel}: ${grades.join(", ")}.`;
};

export default getAdvisoryDetails;
